/**
 * @author Kajabi, LLC <info@kajabi.com>
 * @license MIT
 */
import React from "react";
import { Progress } from "@backstage/core";
import Alert from "@material-ui/lab/Alert";
import { useFaults } from "../../hooks/useFaults";
import { Fault } from "../../types";
import { Grid } from "@material-ui/core";
import { FaultCard } from "../FaultCard";
import { SORT_OPTIONS } from "@internal/plugin-honeybadger-api";

interface Props {
  sortBy?: SORT_OPTIONS;
  limit?: string;
}

export const FaultFetch = ({ sortBy, limit }: Props) => {
  const { loading, error, results } = useFaults({ sortBy, limit });

  if (loading) {
    return <Progress />;
  } else if (error) {
    return <Alert severity="error">{error.message}</Alert>;
  }

  if (results) {
    return results.map((fault: Fault) => (
      <Grid item xs={12} key={fault.id}>
        <FaultCard fault={fault} />
      </Grid>
    ));
  }

  return <div data-testid="no-results">No results found</div>;
};
